/**
 * Returns `true` for the primary pointer of the expected type.
 *
 * @param event - The pointer event to validate.
 * @param pointerType - Optional expected `pointerType` (e.g. `'touch'`).
 * @returns Whether the event should be processed.
 */
export const isValidPointer = (
    event: PointerEvent,
    pointerType?: string
): boolean => {
    if (!event.isPrimary) return false;
    
    if (!pointerType) return true;
    
    return event.pointerType === pointerType;
}
